<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-input
			  v-model="key"
			  placeholder="请输入搜索关键词"
			  class="input-with-select"
			>
			  <template #append>
			    <el-button @click="fetchOrders" icon="Search" />
			  </template>
			</el-input>
		</div>
	</div>
	<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
	    <el-tab-pane label="待办" name="first">
			<el-table :data="tableData" style="width: 100%" height="680">
			    <el-table-column fixed prop="username" label="积分发放对象" width="360" />
			    <el-table-column prop="zfje" label="支付金额" width="220" />
				<el-table-column label="医美订单" width="260">
				  <template #default="scope">
					<img @click="exspendImg(scope.row.ymdd)" :src="scope.row.ymdd" class="avatar" />  
				  </template>
				</el-table-column>
				<el-table-column label="支付记录" width="260">
				  <template #default="scope">
					  <img @click="exspendImg(scope.row.zfjl)" :src="scope.row.zfjl" class="avatar" />
				  </template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="220" />
			    <el-table-column fixed="right" label="操作" width="*">
			      <template #default="scope">
					<el-button v-if="userStore.profile?.departmentid===1" link type="primary" size="small" @click="submitData(scope.row)">客服审核</el-button>
					<el-button v-if="userStore.profile?.departmentid===2" link type="primary" size="small" @click="submitCwData(scope.row)">财务审核</el-button>
					<el-button v-if="scope.row.status==='审核中'"  link type="primary" size="small" @click="backApply(scope.row)">驳回申请</el-button>
					<el-button v-if="userStore.profile?.userid===2"  link type="primary" size="small" @click="applyIntegral(scope.row)">发放积分</el-button>
					<el-button link type="primary" size="small" @click="hisData(scope.row)">审批过程</el-button>
			      </template>
			    </el-table-column>
			</el-table>
			<div class="pagination-custom">
				<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
			</div>
		</el-tab-pane>
	    <el-tab-pane label="待阅" name="second">
			<el-table :data="tableData" style="width: 100%" height="680">
			    <el-table-column fixed prop="username" label="积分发放对象" width="360" />
			    <el-table-column prop="zfje" label="支付金额" width="220" />
				<el-table-column label="医美订单" width="260">
				  <template #default="scope">
					<img @click="exspendImg(scope.row.ymdd)" :src="scope.row.ymdd" class="avatar" />  
				  </template>
				</el-table-column>
				<el-table-column label="支付记录" width="260">
				  <template #default="scope">
					  <img @click="exspendImg(scope.row.zfjl)" :src="scope.row.zfjl" class="avatar" />
				  </template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="220" />
			    <el-table-column fixed="right" label="操作" width="*">
			      <template #default="scope">
					<el-button link type="primary" size="small" @click="readData(scope.row)">已阅</el-button>
					<el-button link type="primary" size="small" @click="hisData(scope.row)">审批过程</el-button>
			      </template>
			    </el-table-column>
			</el-table>
			<div class="pagination-custom">
				<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
			</div>
		</el-tab-pane>
	    <el-tab-pane label="已办" name="third">
			<el-table :data="tableData" style="width: 100%" height="680">
			    <el-table-column fixed prop="username" label="积分发放对象" width="360" />
			    <el-table-column prop="zfje" label="支付金额" width="220" />
				<el-table-column label="医美订单" width="260">
				  <template #default="scope">
					<img @click="exspendImg(scope.row.ymdd)" :src="scope.row.ymdd" class="avatar" />  
				  </template>
				</el-table-column>
				<el-table-column label="支付记录" width="260">
				  <template #default="scope">
					  <img @click="exspendImg(scope.row.zfjl)" :src="scope.row.zfjl" class="avatar" />
				  </template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="220" />
			    <el-table-column fixed="right" label="操作" width="*">
			      <template #default="scope">
					<el-button link type="primary" size="small" @click="hisData(scope.row)">审批过程</el-button>
			      </template>
			    </el-table-column>
			</el-table>
			<div class="pagination-custom">
				<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
			</div>
		</el-tab-pane>
	    <el-tab-pane label="已阅" name="fourth">
			<el-table :data="tableData" style="width: 100%" height="680">
			    <el-table-column fixed prop="username" label="积分发放对象" width="360" />
			    <el-table-column prop="zfje" label="支付金额" width="220" />
				<el-table-column label="医美订单" width="260">
				  <template #default="scope">
					<img @click="exspendImg(scope.row.ymdd)" :src="scope.row.ymdd" class="avatar" />  
				  </template>
				</el-table-column>
				<el-table-column label="支付记录" width="260">
				  <template #default="scope">
					  <img @click="exspendImg(scope.row.zfjl)" :src="scope.row.zfjl" class="avatar" />
				  </template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="220" />
			    <el-table-column fixed="right" label="操作" width="*">
			      <template #default="scope">
					<el-button link type="primary" size="small" @click="hisData(scope.row)">审批过程</el-button>
			      </template>
			    </el-table-column>
			</el-table>
			<div class="pagination-custom">
				<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
			</div>
		</el-tab-pane>
		<el-dialog
		    v-model="applyDialogVisible"
		    title="积分发放"
		    width="50%"
		    destroy-on-close
			:modal="false"
		>
				<div class="dialog-cond-dt">
					<label class="dialog-cond-label">发放对象：</label>
					<el-select
						v-model="applyUser"
						filterable
						placeholder="选择人员"
						style="width: 440px"
						:clearable="true"
						disabled
						collapse-tags
					>
						<el-option
						  v-for="item in miniUserDatas"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value"
						/>
					</el-select>
				</div>
				<div class="dialog-cond-dt">
					<label class="dialog-cond-label">支付金额：</label>
					<el-input-number class="w-50 m-2" v-model="zfje" :step="1" disabled/>
				</div>
				<div class="dialog-cond-dt">
					<label class="dialog-cond-label">兑换比例：</label>
					<el-input-number class="w-50 m-2" v-model="dhbl" :step="1"/>
				</div>
				<div class="dialog-cond-dt">
					<label class="dialog-cond-label">兑换积分：</label>
					<el-input-number class="w-50 m-2" v-model="integral" :step="1" disabled/>
				</div>
				<div class="dialog-cond-dt">
					<label class="dialog-cond-label">有效期开始：</label>
					<el-date-picker
					  v-model="startDate"
					  type="datetime"
					  placeholder="选择开始日期时间"
					  size="default"
					  format="YYYY-MM-DD HH:mm:ss"
					  value-format="YYYY-MM-DD HH:m:s"
					/>
				</div>
				<div class="dialog-cond-dt">
					<label class="dialog-cond-label">有效期结束：</label>
					<el-date-picker
					  v-model="endDate"
					  type="datetime"
					  placeholder="选择结束日期时间"
					  size="default"
					  format="YYYY-MM-DD HH:mm:ss"
					  value-format="YYYY-MM-DD HH:m:s"
					/>
				</div>
			<template #footer>
			  <span class="dialog-footer">
			    <el-button @click="applyDialogVisible = false">取消</el-button>
				<el-button @click="submitIntegral">发放</el-button>
			  </span>
			</template>
		</el-dialog>
		<el-dialog
		    v-model="imgVisible"
		    title="预览"
		    width="50%"
		    destroy-on-close
			:modal="false"
		>
			<img :src="imageUrl" class="avatarScan" />  
			<template #footer>
			  <span class="dialog-footer">
			    <el-button @click="imgVisible = false">关闭</el-button>
			  </span>
			</template>
		</el-dialog>
		<el-dialog
		    v-model="bzDialogVisible"
		    title="审核历程"
		    width="70%"
		    destroy-on-close
			:modal="false"
		>
			<el-table :data="hisTableData" border style="width: 100%">
			    <el-table-column prop="nickname" label="操作人" width="160" />
			    <el-table-column prop="receivedate" label="接收时间" width="220" />
			    <el-table-column prop="operatedate" label="操作时间" width="220" />
				<el-table-column prop="opinion" label="意见" />
			</el-table>
			<template #footer>
			  <span class="dialog-footer">
			    <el-button @click="bzDialogVisible = false">关闭</el-button>
			  </span>
			</template>
		</el-dialog>
		<el-dialog
		    v-model="subDialogVisible"
		    :title="subTitle"
		    width="50%"
		    destroy-on-close
			:modal="false"
		>
			<div v-if="userStore.profile?.departmentid===1" style="width: 100%;display: flex;justify-content: center;align-items: center;">
				<el-transfer 
					v-model="transValue" 
					:data="transData"
					:titles="['可选人员', '已选人员']"
				>
					<template #left-empty>
					  <el-empty :image-size="60" description="No data" />
					</template>
					<template #right-empty>
					  <el-empty :image-size="60" description="No data" />
					</template>
				</el-transfer>	
			</div>
			<div style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 10px;">
				<label style="width:60px;">意见：</label>
				<el-input
				    v-model="opinion"
				    style="width: 100%;"
				    :rows="4"
				    type="textarea"
				    placeholder="请输入意见"
				/>
			</div>
			<template #footer>
			  <span class="dialog-footer">
			    <el-button @click="subDialogVisible = false">取消</el-button>
				<el-button @click="submitReq">提交</el-button>
			  </span>
			</template>
		</el-dialog>
		<el-dialog
		    v-model="backDialogVisible"
		    title="驳回意见"
		    width="50%"
		    destroy-on-close
			:modal="false"
		>
			<div style="width: 100%;display: flex;justify-content: center;align-items: center;margin-top: 10px;">
				<label style="width:60px;">意见：</label>
				<el-input
				    v-model="backOpinion"
				    style="width: 100%;"
				    :rows="4"
				    type="textarea"
				    placeholder="请输入意见"
				/>
			</div>
			<template #footer>
			  <span class="dialog-footer">
			    <el-button @click="backDialogVisible = false">取消</el-button>
				<el-button @click="submitBackReq">提交</el-button>
			  </span>
			</template>
		</el-dialog>
	  </el-tabs>
</template>

<script setup>
	import { ref,provide,inject,onMounted } from 'vue';
	import axios from 'axios';
	import { useMemberStore } from '../../stores';
	import { ElMessage } from 'element-plus'
	const exspendImg=(url)=>{
		imgVisible.value = true
		imageUrl.value = url;
	}
	const backDialogVisible = ref(false)
	const backOpinion = ref('')
	const backApply=(e)=>{
		billid.value = e.id;
		backDialogVisible.value = true;
		backOpinion.value = '';
	}
	const submitBackReq=async()=>{
		const response = await axios.post('/integral/info/backApply', {
			billid:billid.value,
			opinion:backOpinion.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '驳回成功!',
				type: 'success',
			})
			backDialogVisible.value = false
			fetchOrders()
		}else{
			ElMessage({
				message: `${response.data.msg}`,
				type: 'fail',
			})
		}
	}
	const startDate = ref('')
	const endDate = ref('')
	//发放积分、结束审批
	const submitIntegral = async() =>{
		const res = await axios.post('/integral/info/fafangIntegral', {
			billid:billid.value,
			appUser:applyUser.value,
			integral:integral.value,
			startDate:startDate.value,
			endDate:endDate.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(res.data.status===0){
			applyDialogVisible.value = false
			ElMessage({
				message: '发放成功!',
				type: 'success',
			})
			fetchOrders()
		}else{
			ElMessage({
				message: `${res.data.msg}`,
				type: 'fail',
			})
		}
	}
	const zfje = ref(0)
	const dhbl = ref(10000)
	const integral = ref(0)
	const applyUser = ref(-1)
	const miniUserDatas = ref([])
	const applyDialogVisible = ref(false)
	const applyIntegral = async(e) =>{
		billid.value = e.id
		zfje.value = e.zfje;
		applyUser.value = e.apply_user
		integral.value = Math.floor(zfje.value/dhbl.value)
		applyDialogVisible.value = true
		const res = await axios.post('/coupon/yhq/queryMiniUserList', {}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(res.data.status===0){
			miniUserDatas.value = res.data.data.map(item=>{
				return {
					label:item.id+"/"+item.name+"/"+item.mobile,
					value:item.id,
				}
			})
		}
	}
	const imageUrl = ref('')
	const imgVisible = ref(false)
	const userStore = useMemberStore();
	const bzDialogVisible = ref(false)
	const subTitle = ref('提交财务/经理审核')
	const subDialogVisible = ref(false)
	const transData = ref([])
	const transValue = ref([])
	const opinion = ref('同意。')
	const submitReq= async() =>{
		if(userStore.profile?.departmentid===1&&transValue.value.length===0){
			return ElMessage({
				message: '请选择人员!',
				type: 'fail',
			});
		}
		if(userStore.profile?.departmentid===2){
			transValue.value = ''
		}
		const response = await axios.post('/integral/info/flowNext', {
			billid:billid.value,
			opinion:opinion.value,
			nextUserId:transValue.value.toString()
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '提交成功!',
				type: 'success',
			})
			subDialogVisible.value = false
			fetchOrders()
		}else{
			ElMessage({
				message: `${response.data.msg}`,
				type: 'fail',
			})
		}
	}
	//财务提交  只需要记录意见
	const submitCwData=(e)=>{
		billid.value = e.id
		opinion.value = ''
		if(userStore.profile?.departmentid===1){
			subTitle.value = '提交财务/经理审核'
		}else if(userStore.profile?.departmentid===2){
			subTitle.value = '提交经理审核'
		}
		subDialogVisible.value = true
	}
	const submitData = async(e) =>{
		billid.value = e.id
		subDialogVisible.value = true;
		if(userStore.profile?.departmentid===1){
			subTitle.value = '提交财务/经理审核'
		}else if(userStore.profile?.departmentid===2){
			subTitle.value = '提交经理审核'
		}
		const response = await axios.post('/integral/info/queryNextUsers', {
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		transValue.value = []
		transData.value = []
		if(response.data.status===0){
			response.data.data.map(item=>{
				transData.value.push({
					key:`${item.id}`,
					label:`${item.nickname}`
				})
				transValue.value.push(`${item.id}`)
			})
		}
	}
	const readData = async(e) =>{
		billid.value = e.id
		const response = await axios.post('/integral/info/readApply', {
		  billid:e.id
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '已阅成功!',
				type: 'success',
			})
			fetchOrders()
		}else{
			ElMessage({
				message: `${response.data.msg}`,
				type: 'fail',
			})
		}
	}
	const hisTableData = ref([])
	const hisData = async(e) =>{
		billid.value = e.id
		bzDialogVisible.value = true
		const response = await axios.post('/integral/info/queryLogByApply', {
		  billid:e.id
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			hisTableData.value = response.data.data;
		}
	}
	const activeName = ref('first')
	const handleClick=(tab, event)=>{
		pageNo.value = 1;
		if(tab.props.name==='first'){
			initStatus.value = 0;
			initMark.value = 0
		}else if(tab.props.name==='second'){
			initStatus.value = 0;
			initMark.value = 1
		}else if(tab.props.name==='third'){
			initStatus.value = 1;
			initMark.value = 2
		}else if(tab.props.name==='fourth'){
			initStatus.value = 1;
			initMark.value = 4
		}
		fetchOrders()
	}
	const pageNo = ref(1);
	const pageSize = ref(20);
	const total = ref(0);
	const searchType = ref(0);
	const key = ref('');
	const type = ref('');
	const tableData = ref([]);
	const billid = ref('');
	const initStatus = ref(0)
	const initMark = ref(0)
	onMounted(async()=>{
		fetchOrders()
	})
	const fetchOrders = async () => {
		searchType.value = 0;
		const response = await axios.post('/integral/info/queryApplies', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		  status:initStatus.value,
		  isremark:initMark.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	};
	const deleteData=async(e)=>{
		const response = await axios.post('/integral/info/deleteApply', {
		  billid:e.id,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '删除成功!',
				type: 'success',
			})
			fetchOrders()
		}else{
			ElMessage({
				message: `${response.data.msg}`,
				type: 'fail',
			})
		}
		
	}
	const changePageNo = (val) => {
		pageNo.value = val;
		fetchOrders();
	}
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.search-jsj-tatle{
		width: 50%;
		margin: 0 0 0 50%;
	}
	.dialog-cond-dt{
		margin: 0 0 0 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
	.avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatarScan{
		width: 100%;
		height: 600px;
		display: block;
	}
	.dialog-cond-dt{
		margin: 20px 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
</style>